// types
import { FEATURE_FLAGS } from "../feature-flag";
import type { RemoteConfigType } from "./types";

export const defaultConfig: RemoteConfigType = {
  [FEATURE_FLAGS.AUDIO_NOTES]: true,
  // Available for administrators to enable; off by default via alwaysOnFeatures.
  [FEATURE_FLAGS.ALLOW_ALL_USERS_TO_ADD_COMMENTS]: true,
  [FEATURE_FLAGS.CORRECTIVE_ACTIONS]: true,
  [FEATURE_FLAGS.DOCUMENTS]: true,
  [FEATURE_FLAGS.DOCUMENT_ACKNOWLEDGMENTS]: true,
  [FEATURE_FLAGS.FORMS]: true,
  [FEATURE_FLAGS.PEOPLE_MANAGEMENT]: true,
  [FEATURE_FLAGS.PUBLIC_REGISTRATION]: true,
  [FEATURE_FLAGS.PUBLIC_SHARE_EQUIPMENT]: true,
  [FEATURE_FLAGS.PUBLIC_SHARE_CONTRACTORS]: true,
  [FEATURE_FLAGS.PUBLIC_SHARE_DOCUMENTS]: true,
  [FEATURE_FLAGS.PUBLIC_SHARE_JOBS]: true,
  [FEATURE_FLAGS.TASKS]: true,
  [FEATURE_FLAGS.NOTIFICATIONS]: true,
  [FEATURE_FLAGS.DOCUMENTS_OFFLINE]: true,
  [FEATURE_FLAGS.FORMS_OFFLINE]: true,
  [FEATURE_FLAGS.VIDEO_MANAGEMENT]: true,
  [FEATURE_FLAGS.TRAINING_CERT]: true,

  // can be turned an
  [FEATURE_FLAGS.SITE_MANAGEMENT]: true,
  [FEATURE_FLAGS.TO_DO_LIST]: true,
  [FEATURE_FLAGS.DEV_ONLY]: true,
  [FEATURE_FLAGS.DASHBOARD]: true,
  [FEATURE_FLAGS.QUEUES]: true,
  [FEATURE_FLAGS.SCHEDULER]: true,

  [FEATURE_FLAGS.CONTRACTOR_MANAGEMENT]: true,
  [FEATURE_FLAGS.SYSTEM_EXPORT]: true,
  [FEATURE_FLAGS.EQUIPMENT_MANAGEMENT]: true,
  [FEATURE_FLAGS.LANGUAGE]: true,
  [FEATURE_FLAGS.NONLINEAR_WORKFLOW]: true,
  [FEATURE_FLAGS.WORKFLOW_ROUTING]: true,
  [FEATURE_FLAGS.NONLINEAR_TRAINING]: true,
  [FEATURE_FLAGS.PROJECT_MANAGEMENT]: true,
  [FEATURE_FLAGS.WEBHOOKS]: true,
  [FEATURE_FLAGS.PIN_MAP]: true,
  [FEATURE_FLAGS.CLIMATE_API]: true,
  [FEATURE_FLAGS.DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT]: true,
  // Must be true here so it is included in availableFlags; tenant default is off via alwaysOnFeatures.
  [FEATURE_FLAGS.DISABLE_FORM_DUPLICATION]: true,

  // unavailable
  [FEATURE_FLAGS.JHA]: false,
  [FEATURE_FLAGS.REPORTS]: false,
  [FEATURE_FLAGS.STANDARDS]: false,
  [FEATURE_FLAGS.DIVISION_MANAGEMENT]: false,
  dateFormat: "DD/MM/YYYY",
};

export const alwaysOnFeatures: RemoteConfigType = {
  [FEATURE_FLAGS.AUDIO_NOTES]: false,
  [FEATURE_FLAGS.ALLOW_ALL_USERS_TO_ADD_COMMENTS]: false,
  [FEATURE_FLAGS.CORRECTIVE_ACTIONS]: true,
  [FEATURE_FLAGS.DOCUMENTS]: true,
  [FEATURE_FLAGS.DOCUMENT_ACKNOWLEDGMENTS]: false,
  [FEATURE_FLAGS.FORMS]: true,
  [FEATURE_FLAGS.TRAINING_CERT]: true,
  [FEATURE_FLAGS.PEOPLE_MANAGEMENT]: true,
  [FEATURE_FLAGS.PUBLIC_REGISTRATION]: true,
  [FEATURE_FLAGS.PUBLIC_SHARE_EQUIPMENT]: false,
  [FEATURE_FLAGS.PUBLIC_SHARE_CONTRACTORS]: false,
  [FEATURE_FLAGS.PUBLIC_SHARE_DOCUMENTS]: false,
  [FEATURE_FLAGS.PUBLIC_SHARE_JOBS]: false,
  [FEATURE_FLAGS.TASKS]: true,
  [FEATURE_FLAGS.NOTIFICATIONS]: true,
  [FEATURE_FLAGS.DOCUMENTS_OFFLINE]: true,
  [FEATURE_FLAGS.FORMS_OFFLINE]: true,
  [FEATURE_FLAGS.VIDEO_MANAGEMENT]: true,

  // flags that not an be default
  [FEATURE_FLAGS.SITE_MANAGEMENT]: false,
  [FEATURE_FLAGS.PIN_MAP]: false,
  [FEATURE_FLAGS.CLIMATE_API]: false,
  [FEATURE_FLAGS.DEV_ONLY]: false,
  [FEATURE_FLAGS.TO_DO_LIST]: false,
  [FEATURE_FLAGS.DASHBOARD]: false,
  [FEATURE_FLAGS.QUEUES]: false,
  [FEATURE_FLAGS.SCHEDULER]: false,

  [FEATURE_FLAGS.DIVISION_MANAGEMENT]: false,
  [FEATURE_FLAGS.NONLINEAR_WORKFLOW]: false,
  [FEATURE_FLAGS.WORKFLOW_ROUTING]: false,
  [FEATURE_FLAGS.NONLINEAR_TRAINING]: false,
  [FEATURE_FLAGS.WEBHOOKS]: false,
  [FEATURE_FLAGS.DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT]: false,
  [FEATURE_FLAGS.DISABLE_FORM_DUPLICATION]: false,

  // unavailable flags
  [FEATURE_FLAGS.JHA]: false,
  [FEATURE_FLAGS.CONTRACTOR_MANAGEMENT]: false,
  [FEATURE_FLAGS.EQUIPMENT_MANAGEMENT]: false,
  [FEATURE_FLAGS.REPORTS]: false,
  [FEATURE_FLAGS.STANDARDS]: false,
  [FEATURE_FLAGS.SYSTEM_EXPORT]: true,
  [FEATURE_FLAGS.LANGUAGE]: false,
  [FEATURE_FLAGS.PROJECT_MANAGEMENT]: false,
  dateFormat: "DD/MM/YYYY",
};
